"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetValueContext = exports.FieldsContext = void 0;
const react_1 = __importDefault(require("react"));
const throttle_debounce_1 = require("throttle-debounce");
const react_jss_1 = require("react-jss");
const utils_1 = require("./utils");
exports.FieldsContext = react_1.default.createContext({});
// eslint-disable-next-line @typescript-eslint/no-empty-function
exports.SetValueContext = react_1.default.createContext(() => { });
/**
 * Initiates a scope of new form.
 */
const Form = ({ fields, mandatory: mandatoryFields, allMandatory, component, onChange, isFieldGroup, runOnChangeInitially, onEnterPress, className = '', children, }) => {
    const [fieldsData, setFieldsData] = react_1.default.useState((0, utils_1.initiateFormFields)(fields, allMandatory ? fields : mandatoryFields));
    const theme = (0, react_jss_1.useTheme)();
    react_1.default.useEffect(() => {
        setFieldsData(prevState => (0, utils_1.updateMandatory)(prevState, allMandatory ? fields : mandatoryFields));
    }, [mandatoryFields]);
    const debouncedOnChange = react_1.default.useCallback((0, throttle_debounce_1.debounce)(500, (nextValue, hasErrors, name) => onChange && onChange(nextValue, hasErrors, name)), []);
    const setValue = (name, value, mandatory, options) => {
        if (onEnterPress && (options === null || options === void 0 ? void 0 : options.forceSubmit)) {
            onEnterPress((0, utils_1.getValues)(fieldsData));
        }
        if (!name) {
            // Not providing field name - a method to reset the whole form.
            setFieldsData((0, utils_1.initiateFormFields)(fields, allMandatory ? fields : mandatoryFields));
        }
        else {
            setFieldsData((prevState) => {
                const fieldsData = Object.assign(Object.assign({}, prevState), (0, utils_1.processField)(name, value, mandatory || false, options, theme.textLabels, theme.customValidationFunction));
                if (onChange) {
                    // If onChange prop is present, run it on every form change,
                    // except the initial load. When runOnChangeInitially prop is present,
                    // run it also on Initial load.
                    const formIsInitiated = Object.values(prevState)
                        .every((item) => typeof item.value === 'undefined');
                    if (!formIsInitiated || runOnChangeInitially || isFieldGroup) {
                        debouncedOnChange((0, utils_1.getValues)(fieldsData), (0, utils_1.formHasErrors)(fieldsData), name);
                    }
                }
                return fieldsData;
            });
        }
    };
    // Prevent nesting <form> tags when using form as a Fieldgroup.
    const Component = isFieldGroup ? 'div' : component || 'form';
    return (react_1.default.createElement(Component, { className: className || undefined },
        react_1.default.createElement(exports.FieldsContext.Provider, { value: fieldsData },
            react_1.default.createElement(exports.SetValueContext.Provider, { value: setValue }, children))));
};
exports.default = Form;
